import { Component } from '@angular/core';
import { AbstractFieldReadComponent } from '../base-field/abstract-field-read.component';

@Component({
  template: `<span class="text-16 preserve-white-space">{{caseField.value}}</span>`
})
export class ReadTextFieldComponent extends AbstractFieldReadComponent {}
